<template>
  <div class="page-container">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="200px"
      class="changePwd"
    >
      <el-form-item label="当前登录用户" prop="">
        <el-input v-model="userName" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="当前密码" prop="password">
        <el-input
          v-model="form.password"
          placeholder="请输入当前密码"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          v-model="form.newPassword"
          placeholder="请输入新密码"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input
          placeholder="请确认新密码"
          v-model="form.confirmPassword"
          show-password
        ></el-input>
      </el-form-item>
      <div class="form-footer">
        <el-button type="primary" @click="saveForm">保 存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { changePasword } from "@/common/api.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      isShowNode: true,
      form: {
        userType: 0,
        password: null,
        newPassword: null,
        confirmPassword: null,
        userId: "",
      },
      userName: "",
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        password: [
          { required: true, message: "请输入当前密码", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, validator: this.testPassword, trigger: "blur" },
          // { required: true, message: "请再次输入新密码", trigger: "blur" },
        ],
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    close() {},
    isExpand() {
      this.isShowNode = !this.isShowNode;
      console.log(this.isShowNode);
    },
    testPassword(rule, value, callback) {
      if (value) {
        if (value!==this.form.newPassword) {
          callback(new Error("两次输入的密码不一致"));
        } 
        callback();
      } else {
        callback(new Error("请再次输入新密码"));
      }
    },
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.userId = window.sessionStorage.getItem("userId");
          var params = this.form;
          changePasword(params).then((res) => {
            if (res.errorCode == 200) {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              this.$nextTick(() => {
                this.$refs["form"].resetFields();
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
  created() {},
  mounted() {
    this.userName = window.sessionStorage.userName;
  },
};
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  .changePwd {
    padding: 20px 50px;
    background-color: #ffffff;
    border-radius: 6px;
    margin: 50px auto 0;
    width: 50%;
  }
  .form-footer {
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/user/baseInfo/companychangePassword.vue